require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-lesotho-pathways-to-sustainable-livelihoods-project.json") })
        }
      }, "path---en-us-project-lesotho-pathways-to-sustainable-livelihoods-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-lesotho-pathways-to-sustainable-livelihoods-project!./.cache/json/en-us-project-lesotho-pathways-to-sustainable-livelihoods-project.json
// module id = 537
// module chunks = 231608221292675